import { getRequest } from '../api-handler';
import { GradeDetailDto, GradeDto } from './grade';

export const GradeApi = {
  getById: (id: number) => getRequest<GradeDetailDto>(`/grades/${id}`),
  getByRunSystem: (runSystemId: number) =>
    getRequest<GradeDto[]>(`/grades/runsystem/${runSystemId}`)
};
